<div *ngIf="type == ADVERTISERS" class="title">
	Select Advertisers &nbsp;&nbsp; ({{ selectedItems.length }}/{{maxAdvertisersAllowed}})
	<div *ngIf="selectedItems.length > 0" class="unselect-btn-container">
		<a (click)="unselectAll()" class="btn btn-sm btn-secondary">Unselect all</a>
	</div>
</div>
<div *ngIf="type != ADVERTISERS" class="title">
	Select Campaigns
	<div
		*ngIf="type != ADVERTISERS && dropdownList.length > 0"
		class="checkbox-container unselect-btn-container select-all-checkbox"
		(click)="toggleAll()"
	>
		<a *ngIf="selectAll; else UnselectElseBlock" title="Select All" class="select-all-label">Unselect All</a>
		<ng-template #UnselectElseBlock>
			<a title="Select All" class="select-all-label">Select All</a>
		</ng-template>
	</div>
</div>
<ng-select
	#api
	[labelForId]="type"
	[items]="dropdownList"
	[multiple]="dropdownSettings.multiple"
	[closeOnSelect]="dropdownSettings.closeOnSelect"
	[clearable]="dropdownSettings.clearable"
	[selectOnTab]="dropdownSettings.selectOnTab"
	[virtualScroll]="dropdownSettings.virtualScroll"
	[maxSelectedItems]="dropdownSettings.maxSelectedItems"
	[clearAllText]="dropdownSettings.clearAllText"
	[notFoundText]="dropdownSettings.notFoundText"
	[compareWith]="compareWithFn"
	placeholder="{{ dropdownSettings.placeholder }}"
	bindLabel="itemName"
	(add)="onAdd($event)"
	(open)="onOpen($event)"
	(close)="onClose($event)"
	(remove)="onRemove($event)"
	[(ngModel)]="selectedItems"
>
	<!-- <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
		<div class="ng-value" *ngIf="items.length > 1">
			<div class="ng-value-label">{{ selectedItems.length }} selected</div>
		</div>
		<div class="ng-value" *ngIf="items.length === 1">
			<div class="ng-value-label">{{ items[0].itemName }}</div>
		</div>
	</ng-template>
	<ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
		<div class="ng-value" *ngIf="items.length >= 0">
			<input
				class="dropdown-search-input"
				type="text"
				placeholder="{{ dropdownSettings.placeholder }}"
				(input)="api.filter($event.target.value)"
			/>
		</div>
	</ng-template> -->
	<ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
		<div class="ng-value" *ngIf="items.length > 1">
			<div class="ng-value-label">{{ selectedItems.length }} selected</div>
		</div>
		<div class="ng-value" *ngIf="items.length === 1">
			<div class="ng-value-label">{{ items[0].itemName }}</div>
		</div>
	</ng-template>

	<ng-template ng-header-tmp>
		<div>
			<input class="dropdown-search-input" type="text" placeholder="Search" (input)="api.filter($event.target.value)" />
		</div>
		<!-- <div *ngIf="type == ADVERTISERS">
            <div *ngIf="selectedItems.length > 0" class="unselect-btn-container">
                <button (click)="unselectAll()" class="btn btn-sm btn-secondary">Unselect all</button>
            </div>
        </div> -->

		<!-- <div *ngIf="type != ADVERTISERS && dropdownList.length > 0" class="checkbox-container unselect-btn-container select-all-checkbox" (click)="toggleAll()">
                <input id="select-all" type="checkbox" name="toggle" [(ngModel)]="selectAll"/>
                <div class="checkmark"></div><div title="Select All" class="select-all-label">Select All</div>
        </div> -->
		<!-- <div class="select-content">
            {{content}}
        </div> -->
	</ng-template>
	<ng-template ng-option-tmp let-item="item" let-index="index">
		<div [class.checkbox-container]="true" [class.item-disabled]="type != ADVERTISERS && !item.active">
			<input id="item-{{ index }}" type="checkbox" [ngModel]="item.selected" />
			<div class="checkmark"></div>
			<div class="multiSelectOptions" title="{{ item.itemName }}">{{ item.itemName }}</div>
		</div>
	</ng-template>
</ng-select>
